export const shakespeare = {
  data: function () {
    return {
      quote: '',
      inProgress: false
    }
  },
  methods: {
    getQuote: function (pickup, dropoff, passengers = 0) {
      var v = this

      var origin = encodeURIComponent(pickup)
      var destination = encodeURIComponent(dropoff)
      var host = process.env.SHAKESPEARE_HOST
      var path = '/quote?origin=' + origin + '&destination=' + destination

      $.ajax({
        url: host + path,
        type: 'GET',
        dataType: 'json',
        beforeSend: function () {
          v.inProgress = true
          v.$emit('quoteInProgress', v.inProgress)
        },
        success: function (data) {
          data.quotes = data.quotes.filter(quote => quote.maxPassengers >= passengers)
          v.quote = data
          v.$emit('quoteReceived', v.quote)
        },
        complete: function () {
          v.inProgress = false
          v.$emit('quoteInProgress', v.inProgress)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clients/shakespeare.js